module.exports = __webpack_public_path__ + "img/zixun_1@2x.99a4578b.png";